import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=5cb1a756&"
import script from "./Ingredients.vue?vue&type=script&lang=js&"
export * from "./Ingredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports